import { render, staticRenderFns } from "./NumbercrunchArticle.vue?vue&type=template&id=49bac375&"
import script from "./NumbercrunchArticle.vue?vue&type=script&lang=js&"
export * from "./NumbercrunchArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports